import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import useAuthStore from "../../store/authStore";
import userService from "../../services/userService";
import { toast } from "sonner";
import { format} from "date-fns"
// Xác định schema kiểm tra dữ liệu bằng Zod
const userSchema = z.object({
  email: z.string().email(),
  name: z.string().min(2, { message: "Tên phải có ít nhất 2 ký tự" }),
  birthDate: z
    .preprocess(
      (arg) => (typeof arg === "string" || arg instanceof Date ? new Date(arg) : arg),
      z.date().refine(
        (date) => date.getFullYear() >= 1900 && date <= new Date(),
        { message: "Ngày sinh không hợp lệ" }
      )
    ),
    gender: z
    .number()
    .refine(value => [1, 2, 3].includes(value), { message: "Vui lòng chọn giới tính" }),
  phone: z.string().regex(/^\d{10}$/, { message: "Số điện thoại phải gồm 10 chữ số" }),
});

const UserForm = () => {
  const { user, refetchUser} = useAuthStore()
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isDirty, isLoading },
  } = useForm({
    resolver: zodResolver(userSchema),
    defaultValues: {
      email: user.email,
      name: user.name || "",
      birthDate: user.birth_date ? format(new Date(user.birth_date), "yyyy-MM-dd") : "", // Chuyển đổi thành "YYYY-MM-DD"
      gender: user.gender || "",
      phone: user.phone || "",
    },
  });

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      birth_date: new Date(data.birthDate).toISOString(), // Chuyển đổi về chuỗi ISO
    };

    try {
      const response = await userService.updateUser(user.id,payload)
      refetchUser()
      toast.success("Cập nhật thành công!")
    } catch (error) {
      console.error(error)
    }

    console.log("Submitted data:", data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <h1 className="text-center text-xl font-[Phudu] font-bold">Thông tin cá nhân</h1>

      {/* Tên */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Tên</label>
        <Input {...register("name")} placeholder="Nhập tên" />
        {errors.name && <p className="text-red-500 text-sm">{errors.name.message}</p>}
      </div>

       {/* Email */}
       <div>
        <label className="block text-sm font-medium text-gray-700">Email</label>
        <Input {...register("email")} placeholder="Nhập email"  disabled={true} />
        {errors.email && <p className="text-red-500 text-sm">{errors.name.message}</p>}
      </div>

      {/* Ngày tháng năm sinh */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Ngày sinh</label>
        <Input
          type="date"
          {...register("birthDate", {
            required: "Vui lòng chọn ngày sinh"
          })}
        />
        {errors.birthDate && <p className="text-red-500 text-sm">{errors.birthDate.message}</p>}
      </div>

      {/* Giới tính */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">Giới tính</label>
        <RadioGroup
        defaultValue={String(user.gender || "")} // Chuyển giá trị khởi tạo từ số thành chuỗi
        onValueChange={(value) => setValue("gender", Number(value))} // Chuyển string thành number
        className="flex flex-row gap-4 items-center"
      >
        <RadioGroupItem value="1" id="male" />
        <label htmlFor="male" className="ml-2">Nam</label>

        <RadioGroupItem value="2" id="female" />
        <label htmlFor="female" className="ml-2">Nữ</label>

        <RadioGroupItem value="3" id="other" />
        <label htmlFor="other" className="ml-2">Khác</label>
      </RadioGroup>
        {errors.gender && <p className="text-red-500 text-sm">{errors.gender.message}</p>}
      </div>

      {/* Số điện thoại */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Số điện thoại</label>
        <Input {...register("phone")} placeholder="Nhập số điện thoại" />
        {errors.phone && <p className="text-red-500 text-sm">{errors.phone.message}</p>}
      </div>

      {/* Nút gửi */}
      <div className="text-center space-x-4">
      <Button type="submit" className="rounded-full mt-4 bg-green-400" isLoading={isLoading} disabled={!isDirty}>
        Cập nhật
      </Button>
      <Button type="submit" className="rounded-full mt-4" disabled={!isDirty}>
        Hủy
      </Button>
      </div>
    </form>
  );
};

export default UserForm;

